<div class="header" *ngIf="!(navigationService.useMobileNav$ | async)">
    <div *ngIf="branch.icon.icon" class="header-media">
        <fui-icon class="header-media-object" [height]="branch.icon.height" [icon]="branch.icon.icon"
                  id="icon" [width]="branch.icon.width"></fui-icon>
    </div>
    <div class="header-label">
        <div class="header-label-title" id="title">
            {{branch.title | translate}}
        </div>
    </div>
</div>
<div class="links">
    <ng-container *ngFor="let link of branch.links; let index = index">
        <fui-navigation-group id="group-{{index}}" [group]="link" *ngIf="link.links && (link.availability | async) !== FUINavigationLinkAvailability.UNAVAILABLE"></fui-navigation-group>
        <fui-navigation-link id="link-{{index}}" [link]="link" *ngIf="!link.links && (link.availability | async) !== FUINavigationLinkAvailability.UNAVAILABLE"></fui-navigation-link>
    </ng-container>
</div>
